import { render } from "./FooterBar.vue?vue&type=template&id=16022167&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=16022167&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16022167"]])

export default __exports__